﻿import device from "current-device";
import { Tooltip, TooltipOptions, TooltipTrigger } from "../tooltip/tooltip";
import { getTranslations } from "../../translations";
import { getProductDetailImpression, sendDataLayer } from "./ecommerce";
import { showNotification } from "../../utilities/notification";

export class socialmedia
{
    constructor()
    {
        const instance = this;

        if ($(".socialnetworks2 .facebook > a, .js-share-facebook").length > 0)
        {
            $(".socialnetworks2:not(.socialfavlist) .facebook:not(.excludeclickevent) > a, .js-share-facebook").on("click", function ()
            {
                var url = "https://www.facebook.com/sharer/sharer.php?u=" + document.location.href;

                if ($("#product_full_url").length > 0)
                    url = "https://www.facebook.com/sharer/sharer.php?u=" + $("#product_full_url").val();
                else if ($(this).data("url") !== "{current_url}")
                {
                    var facebookdataurl = $(this).data("url");
                    if (facebookdataurl != undefined && facebookdataurl.length > 0)
                        url = "https://www.facebook.com/sharer/sharer.php?u=" + facebookdataurl;
                }

                window.open(url, 'Facebook', 'width=600,height=600');
                sendFacebookShare();
            });
        }

        if ($(".socialnetworks2 .twitter > a, .js-share-x").length > 0)
        {
            $(".socialnetworks2:not(.socialfavlist) .twitter:not(.excludeclickevent) > a, .js-share-x").on("click", function ()
            {
                var prodName = "";
                var twitterArticleUrl = document.location.href;
                var twitterDataUrl = $(this).data("url");
                var twitterDataProductName = $(this).data("productname");
                if (twitterDataUrl != undefined && twitterDataUrl.length > 0 && twitterDataUrl !== "{current_url}")
                    twitterArticleUrl = twitterDataUrl;
                else
                    twitterArticleUrl = document.location.href;
                if (twitterDataProductName != undefined && twitterDataProductName.length > 0)
                    prodName = twitterDataProductName;

                if (prodName.length <= 0)
                    prodName = $(".product-detail h1 > span").text();
                if (prodName.length <= 0)
                    prodName = $(".product-detail h1").text();

                var url = "https://www.x.com/share?url=" + encodeURIComponent(twitterArticleUrl) + "&text=" + encodeURIComponent(prodName) + " bij @" + $(".socialnetworks2 .twitter > a").data("account");
                window.open(url, 'Twitter', 'width=600,height=600');
                sendTwitterShare();
            });
        }

        if ($(".socialnetworks2 .pinterest > a, .js-share-pinterest").length > 0)
        {
            $(".socialnetworks2 .pinterest:not(.excludeclickevent) > a, .js-share-pinterest").on("click", function ()
            {
                var pinterestUrl = document.location.href;
                var pinterestDataUrl = $(this).data("url");
                if (pinterestDataUrl != undefined && pinterestDataUrl.length > 0)
                    pinterestUrl = pinterestDataUrl;

                var favoriteHash = $(this).data("hash");
                if (favoriteHash != undefined && favoriteHash.length > 0)
                    pinterestUrl += "/favoritelist/hash/" + favoriteHash;

                let url = "//nl.pinterest.com/pin/create/button/?url=" + encodeURIComponent(pinterestUrl) +
                    "&media=" + encodeURIComponent($(".slideset .slide:first picture img").prop("src")) +
                    "&description=" + encodeURIComponent($(".heading-holder h1 > span").text());
                window.open(url, 'Pinterest', 'width=600,height=600');
                sendPinterestShare();
            });
        }

        if ($(".socialnetworks2 .whatsapp > a, .js-share-whatsapp").length > 0)
        {
            $(".socialnetworks2 .whatsapp > a, .js-share-whatsapp").on("click", function () {
                let url = "https://wa.me/?text=Wat%20vind%20je%20hiervan?%20" + document.location.href + "?utm_source=whatsapp%26utm_medium=social%26utm_campaign=product_delen%26utm_content=106688";

                if ($(this).data("url") !== "{current_url}") 
                    url = "https://wa.me/?text=Wat%20vind%20je%20hiervan?%20" + $(this).data("url") + "?utm_source=whatsapp%26utm_medium=social%26utm_campaign=product_delen%26utm_content=106688";

                var favoriteAccount = $(this).data("account");
                var favoriteHash = $(this).data("hash");
                var favoriteName = $(this).data("name");
                if (favoriteAccount != undefined && favoriteAccount.length > 0 &&
                    favoriteHash != undefined && favoriteHash.length > 0 &&
                    favoriteName != undefined && favoriteName.length > 0)
                    url = "https://wa.me/?text=Favorieten%20van%20" + favoriteName + "%20bij%20" + favoriteAccount + "%20" + $(this).data("url") + "/favoritelist/hash/" + favoriteHash + "?utm_source=whatsapp%26utm_medium=social%26utm_campaign=product_delen%26utm_content=106688";

                window.open(url, 'Whatsapp', 'width=600,height=600');
                sendWhatsappShare();
            });
        }

        if ($(".socialnetworks2 .share-link > a, .js-share-link").length > 0)
            this.shareLink();
    }

    private shareLink()
    {
        const instance = this;
        if (device.mobile() && navigator.share)
        {
            $(".socialnetworks2 .share-link > a, .js-share-link").on("click", function (e)
            {
                var articleLink = document.location.href;
                var dataUrl = $(this).data("url");
                if (dataUrl != undefined && dataUrl.length > 0 && dataUrl !== "{current_url}")
                    articleLink = dataUrl;

                var favoriteHash = $(this).data("hash");
                if (favoriteHash != undefined && favoriteHash.length > 0)
                    articleLink += "/favoritelist/hash/" + favoriteHash;

                e.preventDefault();
                e.stopPropagation();
                navigator.share({
                    title: $("#header .logo > a").text(),
                    text: getTranslations().txtshareArticleText,
                    url: articleLink,
                }).then(function () { sendmobilelinkShare() }).catch(function (err) { console.log('Error sharing', err) });
            });
            return false;
        }
        else
        {

            $(".socialnetworks2 .share-link > a, .js-share-link").on("click", function (e)
            {
                var articleLink = document.location.origin;
                var dataUrl = $(this).data("url");
                if (dataUrl != undefined && dataUrl.length > 0 && dataUrl !== "{current_url}")
                    articleLink = dataUrl;
                else
                    articleLink = document.location.href;

                var favoriteHash = $(this).data("hash");
                if (favoriteHash != undefined && favoriteHash.length > 0)
                    articleLink += "/favoritelist/hash/" + favoriteHash;

                e.preventDefault();
                e.stopPropagation();
                var $temp = $("<input>");
                var $url = articleLink;
                $("body").append($temp);
                $temp.val($url).trigger('select');
                document.execCommand("copy");
                $temp.remove();

                showNotification({ status: "success", message: getTranslations().txtshareLinkCopy });

                sendLinkShare();
            });
        }
    }
}

// Public methods
export const sendTwitterShare = () =>
{
    sendTwitterSharePath(document.location.pathname);
};
(window as any).sendTwitterShare = sendTwitterShare;

export const sendTwitterSharePath = (path) =>
{
    path = path.replace(window.location.protocol + "//" + window.location.host, "");

    sendDataLayer({
        'socialNetwork': 'twitter',
        'socialAction': 'share',
        'socialTarget': document.location.pathname,
        'event': 'socialClick',
        'ecommerce': {
            'items': [getProductDetailImpression()]
        }
    });
}
(window as any).sendTwitterSharePath = sendTwitterSharePath;

export const sendPinterestShare = () =>
{
    sendPinterestSharePath(document.location.pathname);
}
(window as any).sendPinterestShare = sendPinterestShare;

export const sendPinterestSharePath = (path) =>
{
    path = path.replace(window.location.protocol + "//" + window.location.host, "");

    sendDataLayer({
        'socialNetwork': 'pinterest',
        'socialAction': 'share',
        'socialTarget': document.location.pathname,
        'event': 'socialClick',
        'ecommerce': {
            'items': [getProductDetailImpression()]
        }
    });
}
(window as any).sendPinterestSharePath = sendPinterestSharePath;

export const sendLinkShare = () =>
{
    sendDataLayer({
        'socialNetwork': 'link',
        'socialAction': 'share',
        'socialTarget': document.location.pathname,
        'event': 'socialClick',
        'ecommerce': {
            'items': [getProductDetailImpression()]
        }
    });
}
(window as any).sendLinkShare = sendLinkShare;

export const sendmobilelinkShare = () =>
{
    sendDataLayer({
        'socialNetwork': 'mobiel-share',
        'socialAction': 'share',
        'socialTarget': document.location.pathname,
        'event': 'socialClick',
        'ecommerce': {
            'items': [getProductDetailImpression()]
        }
    });
}

(window as any).sendmobilelinkShare = sendmobilelinkShare;

export const sendWhatsappShare = () =>
{
    sendDataLayer({
        'socialNetwork': 'Whatsapp',
        'socialAction': 'share',
        'socialTarget': document.location.pathname,
        'event': 'socialClick',
        'ecommerce': {
            'items': [getProductDetailImpression()]
        }
    });
}
(window as any).sendWhatsappShare = sendWhatsappShare;

export const sendFacebookShare = () =>
{
    sendFacebookSharePath(document.location.pathname);
}
(window as any).sendFacebookShare = sendFacebookShare;


export const sendFacebookSharePath = (path) =>
{
    path = path.replace(window.location.protocol + "//" + window.location.host, "");

    sendDataLayer({
        'socialNetwork': 'facebook',
        'socialAction': 'share',
        'socialTarget': document.location.pathname,
        'event': 'socialClick',
        'ecommerce': {
            'items': [getProductDetailImpression()]
        }
    });
}
(window as any).sendFacebookSharePath = sendFacebookSharePath;
